import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
    BaseUserService,
    LocaleService,
    getSignedImageUrlForProfile,
    getSpaceIDFromUrl,
    SupportModalComponent,
    SupportService
} from "@smarterplan/ngx-smarterplan-core";
import { Subscription } from "rxjs";
// import { SupportModalComponent } from "src/app/components/support-modal/support-modal.component";
import { GuidedTourService } from "src/app/museum/guided-tour.service";
// import { SupportService } from "src/app/services/support.service";
import { ProfileEntity } from "src/app/types/types.service";

@Component({
    selector: "museum-user-menu",
    templateUrl: "./museum-user-menu.component.html",
    styleUrls: ["./museum-user-menu.component.scss"],
})
export class MuseumUserMenuComponent implements OnInit {
    @ViewChild("content", { static: true }) content: ElementRef;

    @Input() user: ProfileEntity;

    @Input() isGuide = false;

    isAdmin = false;

    avatar =
        "https://api.iconify.design/mdi-light/account.svg?width=40&color=white";

    menuIsVisible = false;

    userSub: Subscription;

    inVisit: boolean;

    inGuidedTourMission = false;

    constructor(
        private userService: BaseUserService,
        private router: Router,
        private modalService: NgbModal,
        private localeService: LocaleService,
        private guidedTourService: GuidedTourService,
        private supportService: SupportService
    ) {
        this.userSub = this.userService.isChanged.subscribe((isChanged) => {
            if (isChanged) {
                this.user = this.userService.cu;
                this.setRights();
                this.setAvatar();
            }
        });
    }

    ngOnInit(): void {
        this.setRights();
        this.setAvatar();
    }

    ngOnDestroy() {
        this.userSub.unsubscribe();
    }

    setRights() {
        this.inVisit = this.router.url.includes("/museum");
        this.isAdmin = this.userService.isSPAdmin();
        if (this.inVisit) {
            const spaceID = getSpaceIDFromUrl(this.router.url);
            if (spaceID) {
                this.inGuidedTourMission =
                    this.isGuide ||
                    !!this.userService.currentMission(spaceID)
                        .templateMissionID;
            }
        }
    }

    async setAvatar() {
        if (this.user.avatar) {
            await getSignedImageUrlForProfile(this.user).then((url) => {
                if (url) {
                    this.avatar = url;
                }
            });
        }
    }

    async signOut() {
        if (this.guidedTourService.currentTourLive) {
            console.log("Leave live tours before signing out");
            await this.guidedTourService.leaveTour(this.isGuide);
        }
        await this.userService.logoutCurrentAndSignOutAuth();
        this.router.navigate(["connect"]);
    }

    // presentLanguageModal() {
    //     this.modalService.open(this.content, {
    //         ariaLabelledBy: "modal-basic-title",
    //     });
    //     this.onDropdownToggle();
    // }

    // onLangChange(lang: string): void {
    //     this.localeService.change(lang);
    // }

    onDropdownToggle() {
        setTimeout(() => {
            this.menuIsVisible =
                document
                    .querySelector("#menuDropdown")
                    .className.search("show") !== -1;
        }, 100);
    }

    onProfileClick() {
        this.onDropdownToggle();
    }

    openSupportForm() {
        this.supportService.openSupportForm(SupportModalComponent);
    }
}
